import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import HowTechnographicsDriveSmarter from '../components/HowTechnographicsDriveSmarter'

export default function HowTechnographicsDriveSmarterGtmAbmAndCompetitiveAdvantage() {
  return (
    <div>
      <Header1/>
      <HowTechnographicsDriveSmarter/>
      <Footer/>
    </div>
  )
}
